import React, { useEffect, useState } from 'react'
import UserContainerComponent from '../../../components/usersComponents/UserContainerComponent';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { useParams } from 'react-router-dom';
import DataAPI from '../../../api/DataApi';
import Utilidades from '../../../services/Utilidades';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';

function ClientsData() {
    const { id } = useParams();
    const [data, setdata] = useState<any>({ rnc : '', name: '', path: '' });
    const [date1, setDate1] = useState(new Date());
    const [date2, setDate2] = useState(new Date());
    const [ecfTypeValue, setEcfTypeValue] = useState('00');
    const [ecfStatusValue, setEcfStatusValue] = useState('00');
    const [rncValue, setrncValue] = useState('');
    const [ecfNoValue, setecfNoValue] = useState('');
    const [datos, setDatos] = useState<Array<any>>([]);

    const [showDocument, setShowDocument] = useState<any>();
    const [showRespuestaDGII, setShowRespuestaDGII] = useState<any>();
    const [dataRespuesta, setdataRespuesta] = useState<any>();
    
    //MODAL
    const [ header, setHeader ] = useState('');
    const [ showModal, setShowModal ] = useState(false);
    const [ showModalDGII, setShowModalDGII ] = useState(false);

    const [ eCFTypes, ] = useState([
        {label: 'Todos los Tipos', value: '00'},
        {label: '31. Factura de Crédito Fiscal', value: '31'},
        {label: '32. Factura de Consumo', value: '32'},
        {label: '33. Nota de Débito', value: '33'},
        {label: '34. Nota de Crédito', value: '34'},
        {label: '41. Compras Electrónicas', value: '41'},
        {label: '43. Gastos Menores', value: '43'},
        {label: '44. Regímenes Especiales', value: '44'},
        {label: '45. Gubernamental Electrónico', value: '45'},
        {label: '46. Exportaciones', value: '46'},
        {label: '47. Pagos al Exterior', value: '47'}
    ]);

    const [ eCFStatusses, ] = useState([
        {label: 'Cualquier Estado', value: '00'},
        {label: 'Aceptado', value: 'PA'},
        {label: 'Aceptado Condicional', value: 'PC'},
        {label: 'Rechazado', value: 'E'},
    ]);

    const statusBodyTemplate = (doc:any) => {
        if ( doc.statusdgii_fls === 1 )
        return <Tag className='bg-green-700' value={'Aprobado'} severity={'success'}></Tag>;
        else if ( doc.statusdgii_fls === 4 ) 
        return <Tag value={'Condicional'} severity={'warning'}></Tag>;
        else 
        return <Tag className='bg-red-700' value={'Rechazado'} severity={'success'}></Tag>;
    };
    const formatCurrency = (value:any) => {
        // return value.amount_fls.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        return Utilidades.FormatearANumero(value.amount_fls)
    };

    const optionsTemplate = (value:any) => {
			return (
			<div>
                <div className='space-x-3 flex text-xs items-center'>
                    <Button icon="pi pi-id-card" text aria-label="data" 
                        className='p-0 h-5 w-6 button-table' tooltip='Ver Datos'
                        onClick={() => { mostrarDatos(value) } }
                        />
                    <Button icon="pi pi-download" text aria-label="data" className='p-0 h-5 w-6 button-table' tooltip='Descargar XML'  />
                    <Button icon="pi pi-file-check" text aria-label="data" 
                        className='p-0 h-5 w-6 button-table' tooltip='Verificar en DGII' 
                        visible={ 
                            value.statusdgii_fls === 2 || value.statusdgii_fls === 0 || 
                            ( value.statusdgii_fls === 4 && value.phase_fls !== 'PA' && value.phase_fls !== 'PC' ) 
                            ? true : false } 
                        disabled={ 
                            value.statusdgii_fls === 2 || value.statusdgii_fls === 0 ||
                            ( value.statusdgii_fls === 4 && value.phase_fls !== 'PA' && value.phase_fls !== 'PC' ) 
                            ? false : true } 
                        severity={ 
                            value.statusdgii_fls === 2 || value.statusdgii_fls === 0 ||
                            ( value.statusdgii_fls === 4 && value.phase_fls !== 'PA' && value.phase_fls !== 'PC' ) 
                            ? 'success' : 'secondary' }  
                        onClick={() => verificarDGII(value) } />
                    <Button icon="pi pi-qrcode" text aria-label="data" 
                        className='p-0 h-6 w-7 button-table' tooltip='Verificar QR' 
                        visible={ 
                            value.statusdgii_fls === 2 || value.statusdgii_fls === 0 ||
                            ( value.statusdgii_fls === 4 && value.phase_fls !== 'PA' && value.phase_fls !== 'PC' ) 
                            ? false : true } 
                        disabled={ 
                            value.statusdgii_fls === 2 || 
                            ( value.statusdgii_fls === 4 && value.phase_fls !== 'PA' && value.phase_fls !== 'PC' ) 
                            ? true : false } 
                        severity={ 
                            value.statusdgii_fls === 2 || 
                            ( value.statusdgii_fls === 4 && value.phase_fls !== 'PA' && value.phase_fls !== 'PC' ) 
                            ? 'success' : 'secondary' }  
                        onClick={() => verificarQR(value) } />
                </div>
			</div>
			);
	};

    const footerContent = (
        <div>
            <Button size='small' severity='secondary' label="Cerrar" 
                icon="pi pi-times" autoFocus className='mt-4'
                onClick={() => { setShowModal(false) }} />
        </div>
    );

    const footerContentDGII = (
        <div>
            <Button size='small' severity='secondary' label="Cerrar" 
                icon="pi pi-times" autoFocus className='mt-4'
                onClick={() => { setShowModalDGII(false) }} />
        </div>
    );

    useEffect(() => {
        let token: string = String(localStorage.getItem('token'));
        DataAPI.getCompanyName(token, Number(id)).then((data) => {
            // console.log(data);
            setdata(data);
        }).catch((error) => {
            setdata({ rnc : '', name: '', path: '' });
        });
    
    }, []);
    

    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p className='font-bold mt-2 lg:mt-8 text-lg underline'>e-CF Emitidos</p>
                <div className='flex w-full flex-col space-y-2'>
                    <div className='flex w-full flex-row'>
                        <p className="my-0  font-bold text-base w-4/12 md:w-2/12 xl:w-1/12">
                            Ced/RNC
                        </p>
                        <p className="my-0  ml-6 font-bold text-base text-dsBlue w-8/12 md:w-10/12 xl:w-11/12">
                            {data?.rnc}
                        </p>
                    </div>
                    <div className='flex w-full flex-row'>
                        <p className="my-0 font-bold text-base w-4/12 md:w-2/12 xl:w-1/12">
                            Empresa
                        </p>
                        <p className="my-0 ml-6 font-bold text-base w-8/12 text-dsBlue md:w-10/12 xl:w-11/12">
                            {data?.name}
                        </p>
                    </div>
                </div>
                <div className='grid grid-cols-4 lg:grid-cols-10 gap-1 items-center mt-4 lg:mt-2'>
                    <label htmlFor="fdesde" className="font-bold text-base hidden lg:block col-span-1">
                        Desde
                    </label>
                    <Calendar inputId='fdesde' name='fdesde' value={date1} 
                        onChange={(e:any) => setDate1(e.value)} 
                        dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px] col-span-2'  />
                    <div className='col-span-1 hidden lg:block'>&nbsp;</div>
                    <label htmlFor="fhasta" className="lg:pl-3 font-bold text-base hidden lg:block col-span-1">
                        Hasta
                    </label>
                    <Calendar inputId='fhasta' name='fhasta' value={date2} 
                        onChange={(e:any) => setDate2(e.value)} 
                        dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px] col-span-2' />
                    <div className='col-span-3 hidden lg:block'>&nbsp;</div>
                    <label htmlFor="CBtipoecf" className="font-bold text-base col-span-1">
                        Tipo e-CF
                    </label>
                    <Dropdown inputId='CBtipoecf' name='CBtipoecf' placeholder='Tipo de Comprobante' className='col-span-3' 
                        options={eCFTypes} value={ecfTypeValue}
                        onChange={(e) => { setEcfTypeValue(e.value);}} />
                    <label htmlFor="CBstatus" className="lg:pl-3 font-bold text-base col-span-1">
                        Estado
                    </label>
                    <Dropdown inputId='CBstatus' name='CBstatus' placeholder='Status del Documento' className='col-span-3' 
                        options={eCFStatusses} value={ecfStatusValue}
                        onChange={(e) => { setEcfStatusValue(e.value) }} />
                    <div className='col-span-2 hidden lg:block'>&nbsp;</div>
                    <label htmlFor="TBrnc" className="font-bold text-base col-span-1">
                        RNC/Ced.
                    </label>
                    <InputText id='TBrnc' name='TBrnc' value={rncValue}
                        onChange={(e) => setrncValue(e.target.value)}  
                        placeholder='RNC Comprador' className='col-span-3' />
                    <label htmlFor="TBecf" className="lg:pl-3 font-bold text-base col-span-1">
                        e-CF
                    </label>
                    <InputText id='TBecf' name='TBecf' value={ecfNoValue}
                        onChange={(e) => setecfNoValue(e.target.value)}  
                        placeholder='No. e-NCF' 
                        className='col-span-3' />
                    <Button size='small' id='Bbuscar' name='Bbuscar'
                        onClick={buscarDatos} 
                        className='web-boton font-bold col-span-4 lg:col-span-2 text-center justify-center'>
                        <i className="material-icons-outlined md-18">search</i>&nbsp;<span  >Buscar Datos</span>
                    </Button>
                </div>
                <div className="card mt-4 select-none">
                    <DataTable className='' value={datos} tableStyle={{ minWidth: '50rem' }}
                        emptyMessage = {'No existen registros.'}>
                        <Column field="encf_fls" header="Documento"></Column>
                        <Column field="created_at" header="Fec. Reg."></Column>
                        <Column field="docDate_fls" header="Fec. Doc."></Column>
                        <Column body={statusBodyTemplate} header="Estado"></Column>
                        <Column body={formatCurrency} header="Monto"></Column>
                        <Column body={optionsTemplate} field="options" header="Opciones"></Column>
                    </DataTable>
                </div>
                <div className='mb-10'></div>
            </div>
            <Dialog draggable={false} header={header} visible={showModal} 
                style={{ width: '50vw' }} onHide={() => setShowModal(false)} 
                footer={footerContent} breakpoints={{ '641px': '95%' }}>
                <form spellCheck={false} style={{ background: '' }}>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            API ID
                        </label>
                        <InputText value={showDocument?.API_ID} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Registrado
                        </label>
                        <InputText value={showDocument?.created_at} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Fecha Doc.
                        </label>
                        <InputText value={showDocument?.docDate_fls} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            RNC/CED.
                        </label>
                        <InputText value={showDocument?.buyer_fls} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Monto
                        </label>
                        <InputText value={Utilidades.FormatearANumero(showDocument?.amount_fls)} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Utilizado DGII
                        </label>
                        <InputText value={showDocument?.ncfUsedByDGII_fls === 1 ? 'Si' : 'No'} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Track ID
                        </label>
                        <InputText value={showDocument?.trackid_fls} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Estado
                        </label>
                        <InputText value={
                                showDocument?.statusdgii_fls === 1 ? 'Aceptado' :
                                showDocument?.statusdgii_fls === 1 ? 'Aceptado Condicional' : 'Rechazado' }
                            disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Cod. Seguridad
                        </label>
                        <InputText value={showDocument?.securitycode_fls} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Firma
                        </label>
                        <InputText value={showDocument?.signatureDate_fls} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <Divider align="left">
                        <div className="inline-flex align-items-center">
                            <i className="pi pi-building mr-2 mt-1"></i>
                            <b>Respuesta DGII</b>
                        </div>
                    </Divider>
                    {
                        dataRespuesta?.error && 
                        <>
                        <div className='flex flex-row items-center'>
                            <label className="font-bold text-base w-2/12">
                                Recepci&oacute;n
                            </label>
                            <InputText value={dataRespuesta?.message?.fechaRecepcion} disabled
                                className='web-disabled select-none w-10/12' />
                        </div>
                        <div className='flex flex-row items-center'>
                            <label className="font-bold text-base w-2/12">
                                Resultado
                            </label>
                            <InputText value={dataRespuesta?.error} disabled
                                className='web-disabled select-none w-10/12' />
                        </div>
                        <div className='flex flex-col mt-1'>
                            <label className="font-bold text-base w-2/12">
                                Mensajes
                            </label>
                            {
                                dataRespuesta?.message?.mensajes?.map((item: any) => {
                                    return <label className="text-base mt-2">
                                        - { item.valor }
                                    </label>
                                })
                            }
                        </div>
                        </>
                    }
                    {
                        ( dataRespuesta?.error === null || dataRespuesta?.error === undefined)  && 
                        <>
                        <div className='flex flex-row items-center'>
                            <label className="font-bold text-base w-2/12">
                                e-NCF
                            </label>
                            <InputText value={dataRespuesta?.encf} disabled
                                className='web-disabled select-none w-10/12' />
                        </div>
                        <div className='flex flex-row items-center'>
                            <label className="font-bold text-base w-2/12">
                                Estado
                            </label>
                            <InputText value={dataRespuesta?.estado} disabled
                                className='web-disabled select-none w-10/12' />
                        </div>
                        <div className='flex flex-col mt-1'>
                            <label className="font-bold text-base w-2/12">
                                Mensajes
                            </label>
                            {
                                dataRespuesta?.mensajes?.map((item: any) => {
                                    return <label className="text-base mt-2">
                                        - { item.valor }
                                    </label>
                                })
                            }
                        </div>
                        </>
                    }
                </form>
            </Dialog>
            <Dialog draggable={false} header={'Datos en Servidores de DGII'} visible={showModalDGII} 
                style={{ width: '50vw' }} onHide={() => setShowModal(false)} 
                footer={footerContentDGII} breakpoints={{ '641px': '95%' }}>
                <form spellCheck={false} style={{ background: '' }}>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            API ID
                        </label>
                        <InputText value={showRespuestaDGII?.API_ID} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Track ID
                        </label>
                        <InputText value={showRespuestaDGII?.trackid_fls} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Fec. Recepci&oacute;n
                        </label>
                        <InputText value={showRespuestaDGII?.fechaRecepcion} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            e-NCF
                        </label>
                        <InputText value={showRespuestaDGII?.encf} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Utilizado DGII
                        </label>
                        <InputText value={showRespuestaDGII?.secuenciaUtilizada === true ? 'Si' : 'No'} disabled
                            className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-row items-center'>
                        <label className="font-bold text-base w-2/12">
                            Estado
                        </label>
                        <InputText value={ showRespuestaDGII?.codigo + ' - ' + showRespuestaDGII?.estado }
                            disabled className='web-disabled select-none w-10/12' />
                    </div>
                    <div className='flex flex-col mt-1'>
                        <label className="font-bold text-base w-2/12">
                            Mensajes
                        </label>
                        {
                            showRespuestaDGII?.mensajes?.map((item: any) => {
                                return <label className="text-base mt-2">
                                    - { item.valor }
                                </label>
                            })
                        }
                    </div>
                </form>
            </Dialog>
        </UserContainerComponent>
    );

    function buscarDatos() {
        let token: string = String(localStorage.getItem('token'));

        DataAPI.getCompanyDocs(token,Number(id)
            , Utilidades.getStringOfDateStandard(date1)
            , Utilidades.getStringOfDateStandard(date2),
            ecfTypeValue, ecfStatusValue,rncValue, ecfNoValue ).then((data) => {
                // console.log(data);
                setDatos(data.objeto);
            });
    }

    function mostrarDatos(value: any) {
        let token: string = String(localStorage.getItem('token'));
        setdataRespuesta([]);
        DataAPI.getDocMessages(token, value.API_ID).then((dataRespuesta) => {
            setdataRespuesta(dataRespuesta?.respuesta);
        });
        setHeader('Documento '+ value.encf_fls);
        console.log(value.API_ID);
        setShowModal(true);
        setShowDocument(value);
    }

    function verificarDGII(item: any) {
        const company = Number(id);
        const API_ID = Number(item.API_ID);
        // let data = 
        // {
        //     "result": true,
        //     "message": "Correcto",
        //     "object": {
        //         "trackId": "ded1d0cd-ca76-4303-9e71-0c554e6ad9ae",
        //         "codigo": "4",
        //         "estado": "Aceptado Condicional",
        //         "rnc": "03102894494",
        //         "encf": "E310000000023",
        //         "secuenciaUtilizada": true,
        //         "fechaRecepcion": "11/18/2024 2:27:49 PM",
        //         "mensajes": [
        //             {
        //                 "valor": "El campo RNCComprador del área Comprador de la sección Encabezado no es válido.",
        //                 "codigo": 1385
        //             }
        //         ]
        //     }
        // };
        
        // addProperty(data.object, 'API_ID', item.API_ID);
        // addProperty(data.object, 'trackid_fls', item.trackid_fls);
        
        // setShowRespuestaDGII(data.object);

        // setTimeout(() => {
        //     setShowModalDGII(true);
        // }, 150);

        DataAPI.checkDocInfoDGIIServer(company, API_ID).then((data) => {
            // console.log(data);
            addProperty(data.object, 'API_ID', item.API_ID);
            addProperty(data.object, 'trackid_fls', item.trackid_fls);
            
            setShowRespuestaDGII(data.object);

            setTimeout(() => {
                setShowModalDGII(true);
            }, 150);
            
        }).catch((error) => {
            console.log(error);
            console.log('error obteniendo respuesta del API de Facturacion Electrónica');
        });
    }

    function addProperty(object: any, property: any, value: any) {
        object[property] = value;
    return object;
    }

    function verificarQR(item: any) {
        // console.log(item);
        const URL = generarLinkQR(item);
        window.open(URL, "_blank","noopener,noreferrer");
    }

    function generarLinkQR(item: any): string {
        let retorno: string = '';
        const monto: number = Number(item.amount_fls);

        if ( monto < 250000 && item.encftype_fls === '32') {
            retorno = generarQRresumen(item);
        } else {
            retorno = generarQR(item);
        }
        
        return retorno;
    }

    function generarQR(item: any) {
        let retorno: string = '';
        let CodigoSeguridad: string = item.securitycode_fls;
        CodigoSeguridad = CodigoSeguridad.replace("+", "%2b").replace("/", "%2F");
        let FechaFirma: string = item.signatureDate_fls;
        FechaFirma = FechaFirma.replace(" ", "%20");
        const rnc: string = item.buyer_fls;
        let strComprador = '&RncComprador='+item.buyer_fls;
        
        console.log(['lenght', rnc.trim().length]);

        if ( rnc.trim().length <= 0 ) {
            strComprador = '';
        }
        const server = 'https://ecf.dgii.gov.do/ecf/consultatimbre';

        retorno = server + "?RncEmisor=" + data?.rnc + strComprador +
            "&ENCF=" + item.encf_fls.trim() + "&FechaEmision=" + item.docDate_fls + "&MontoTotal=" 
            + item.amount_fls +
            "&FechaFirma=" + FechaFirma + "&CodigoSeguridad=" 
            + CodigoSeguridad.trim()
        

        return retorno;
    }

    function generarQRresumen(item: any) {
        let retorno: string = '';
        let CodigoSeguridad: string = item.securitycode_fls;
        CodigoSeguridad = CodigoSeguridad.replace("+", "%2b").replace("/", "%2F");
        const server = 'https://fc.dgii.gov.do/ecf/consultatimbrefc';

        retorno = server + "?RncEmisor=" + data?.rnc + "&ENCF=" +
            item.encf_fls + "&MontoTotal=" + item.amount_fls + "&CodigoSeguridad=" 
            + CodigoSeguridad;

        return retorno;
    }
}

export default ClientsData;